import { __assign } from "tslib";
import { playStoreIconSVGData } from '../assets/svgData/google-play-store.svgData';
import { appStoreIconSVGData } from '../assets/svgData/apple-app-store.svgData';
var externalPropsShared = {
    attributes: {
        rel: 'external noopener noreferrer',
        target: '_blank',
    },
};
var nonRouterProps = {
    routerLink: false,
};
export var actionLinks = [
    __assign({ url: 'https://itunes.apple.com/gb/app/apple-store/id358774767?pt=296051&ct=Mobile%20Web%20homepage&mt=8', icon: appStoreIconSVGData, svgProps: {
            width: 135,
            height: 40,
        }, title: 'App Store' }, externalPropsShared),
    __assign({ url: 'https://play.google.com/store/apps/details?id=uk.co.autotrader.androidconsumersearch&amp;referrer=utm_source%3DMobile%2520Web%2520homepage', icon: playStoreIconSVGData, svgProps: {
            width: 135,
            height: 40,
        }, title: 'Play Store' }, externalPropsShared),
];
export var ATDealersLinks = {
    rowHeading: 'Autotrader for dealers',
    subNav: [
        __assign({ url: 'https://portal.autotrader.co.uk/', displayText: 'Dealer portal' }, nonRouterProps),
        __assign({ url: '/partners/retailer/packages', displayText: 'Advertising packages' }, nonRouterProps),
        __assign({ url: '/partners/retailer/pay-as-you-go', displayText: 'Pay As You Go' }, nonRouterProps),
    ],
};
export var ATGroupLinks = {
    rowHeading: 'Autotrader Group',
    subNav: [
        __assign({ url: '/safety_and_security_centre', displayText: 'Security advice' }, nonRouterProps),
        __assign({ url: '/contact-us', displayText: 'Contact us' }, nonRouterProps),
        __assign({ url: 'https://plc.autotrader.co.uk/', displayText: 'About Autotrader' }, nonRouterProps),
        __assign({ url: 'https://careers.autotrader.co.uk', displayText: 'Careers' }, nonRouterProps),
        __assign({ url: 'https://plc.autotrader.co.uk/investors', displayText: 'Investor information' }, nonRouterProps),
        __assign({ url: '/privacy-notice', displayText: 'Privacy policies and terms' }, nonRouterProps),
        __assign({ url: '/terms-and-conditions/advertising', displayText: 'Terms & conditions' }, nonRouterProps),
        __assign({ url: '/sos', displayText: 'External wellbeing support' }, nonRouterProps),
        __assign({ url: '', displayText: 'Manage cookies' }, nonRouterProps),
    ],
};
